import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './Login.scss';
import Cookies from 'js-cookie';
import { useAuthContext } from '@web/api/src';
import flagDe from '@web/utils/src/assets/icons/language/ic_flag_de.svg';
import flagEn from '@web/utils/src/assets/icons/language/ic_flag_en.svg';
import { env } from '@/env';
import { useUserContext } from '@/provider';
import { register } from '@teamhanko/hanko-elements';

export default function Login({
  redirectAfterLogin,
}: {
  redirectAfterLogin: () => void;
}) {
  const { onLogin } = useUserContext();
  const { hankoLoginCallback } = useAuthContext();
  const langCookie: string = Cookies.get('i18next') || '';
  const lang = langCookie.includes('-') ? langCookie.split('-')[0] : langCookie;

  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    window.location.reload();
  };

  useEffect(() => {
    const afterLoginHook = () => {
      redirectAfterLogin();
      hankoLoginCallback();
      onLogin();
    };
    document.addEventListener('hankoAuthSuccess', () => afterLoginHook());
    return () =>
      document.removeEventListener('hankoAuthSuccess', afterLoginHook);
  }, [onLogin, redirectAfterLogin, hankoLoginCallback]);

  useEffect(() => {
    // register hanko web component the component
    register(env.VITE_HANKO_API_URL).catch((error) => {
      console.warn('unhandled login error', error);
      // handle error
    });
  }, []);

  return (
    <div>
      <hanko-auth lang={lang} />
      <div
        onClick={() => changeLanguage(lang === 'en' ? 'de' : 'en')}
        className="flex justify-end"
      >
        <div className="cursor-pointer">
          <img src={lang === 'en' ? flagDe : flagEn} />
        </div>
      </div>
    </div>
  );
}
